<script lang="ts" setup>
import { IconAi } from '@/icons';

interface Props {
  tag?: string;
  actionLabel?: string;
  actionValue: string;
  description?: string;
}

withDefaults(defineProps<Props>(), {
  tag: undefined,
  actionLabel: 'Suggested Action:',
  description: undefined,
});
</script>

<template>
  <div :class="$style.root" data-ui-component="UiAiSuggest">
    <div :class="$style.iconWrapper">
      <IconAi
        :class="$style.icon"
        width="16"
        height="16"
        aria-hidden="true"
      />
    </div>

    <div :class="$style.content">
      <span v-if="tag" :class="$style.tag">{{ tag }}</span>

      <div :class="$style.data">
        <div :class="$style.actionRow">
          <span :class="$style.actionLabel">{{ actionLabel }}</span>
          <span :class="$style.actionValue">{{ actionValue }}</span>
        </div>
        <div v-if="description" :class="$style.description">{{ description }}</div>
      </div>
    </div>
  </div>
</template>

<style lang="scss" module>
.root {
  display: flex;
  gap: 8px;
  align-items: flex-start;
  padding: 16px;
  border-radius: 8px;
  background: var(--ui2-shade-pine-forest-4, rgba(34, 107, 108, 0.04));
  width: 100%;
  box-sizing: border-box;
  font-family: 'Poppins', sans-serif;
}

.iconWrapper {
  display: flex;
  align-items: center;
  padding: 2px 0;
  flex: none;
}

.icon {
  width: 16px;
  height: 16px;
  color: var(--ui2-data-pine-forest);
}

.content {
  display: flex;
  flex-direction: column;
  flex: 1;
  min-width: 0;
}

.tag {
  display: inline-flex;
  align-self: flex-start;
  align-items: center;
  gap: 2px;
  padding: 2px 4px;
  border-radius: 4px;
  background: var(--ui2-shade-pine-forest-8, rgba(34, 107, 108, 0.08));
  color: var(--ui2-data-pine-forest);
  font-size: 12px;
  font-weight: 500;
  line-height: 16px;
  white-space: nowrap;
}

.data {
  display: flex;
  flex-direction: column;
  gap: 4px;
  padding-top: 8px;
}

.actionRow {
  display: flex;
  gap: 4px;
  align-items: center;
  font-size: 12px;
  font-weight: 600;
  line-height: 16px;
}

.actionLabel {
  color: var(--ui2-content-primary, #010000);
  flex: none;
}

.actionValue {
  color: var(--ui2-background-accent-primary, #226b6c);
  min-width: 0;
  word-break: break-word;
}

.description {
  font-size: 12px;
  font-weight: 500;
  line-height: 16px;
  color: var(--ui2-content-secondary, #655e60);
  word-break: break-word;
}
</style>
